import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import './sovosTooltip.scss';

const SovosTooltip = props => {
  const { id, label, children } = props;

  const custom = children ? React.cloneElement(children, { ['data-tip']: true, ['data-for']: id }) : null;

  const showTooltip = () => { // eslint-disable-line react/no-multi-comp
    if (props.show) {
      const classNameHideArrow = props.hideArrow ? 'hide-arrow' : '';
      return (
        <ReactTooltip
          id={ props.id }
          className={ `${classNameHideArrow} ${props.className}` }
          place={ props.place }
          effect={ props.effect }
        >
          <div style={ {overflowWrap: 'break-word', width: props.contentWidth, color: 'white', fontWeight: 400 } }>{ label }</div>
        </ReactTooltip>
      );
    }
    return null;
  };

  return (
    <span style={ { width: '100%' } }>
      { custom }
      { showTooltip() }
    </span>
  );
};

SovosTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  show: PropTypes.bool,
  place: PropTypes.oneOf(['bottom', 'top', 'right', 'left']),
  effect: PropTypes.oneOf(['float', 'solid']),
  className: PropTypes.string,
  hideArrow: PropTypes.bool,
  children: PropTypes.element,
  multiline: PropTypes.bool,
  contentWidth: PropTypes.number
};

SovosTooltip.defaultProps = {
  label: '',
  show: true,
  place: 'bottom',
  effect: 'float',
  className: '',
  hideArrow: false,
  children: null,
  multiline: false,
  contentWidth: 300
};

export default SovosTooltip;



// WEBPACK FOOTER //
// ./src/shared/sovos-tooltip/SovosTooltip.js